import { defineCustomElement } from 'vue';
import { configureApp } from '@/configure-app';

import AppCe from './App.ce.vue';
import fontAwesomeCSS from '!!raw-loader!@fortawesome/fontawesome-free/css/all.css';
import vitalsCSS from '!!raw-loader!./ce/vitals.css';

export const WbCpp = defineCustomElement(AppCe, {
	configureApp(vueApp) {
		configureApp(vueApp);
	},
	shadowRoot: true,
	styles: [fontAwesomeCSS, vitalsCSS],
});
